import { render, staticRenderFns } from "./BeneficiaryForm.vue?vue&type=template&id=f5157930"
import script from "./BeneficiaryForm.vue?vue&type=script&lang=js"
export * from "./BeneficiaryForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports